<template>
  <ankh-list>
    <template #btn-group>
      <el-button @click.native="handleBatchDelete()">{{ $t('批量删除') }}</el-button>
      <el-button @click.native="handleBatchPass()" v-if="tabCurrent==='RecipeAudit'">{{ $t('批量审核') }}</el-button>
      <el-button @click.native="handleBatchOffline" v-if="tabCurrent === 'OnlineRecipe'">{{ $t('批量下架') }}</el-button>
    </template>

    <template #search-form>
      <el-form-item :label="$t('菜谱编号')">
        <el-input :placeholder="$t('菜谱编号')" v-model="searchForm.num" clearable/>
      </el-form-item>

      <el-form-item :label="$t('菜谱名称')">
        <el-input :placeholder="$t('菜谱名称')" v-model="searchForm.name" clearable/>
      </el-form-item>
      <el-form-item :label="$t('菜谱分类')">
        <el-cascader
            :options="recipeCategoryList"
            :props="cascaderProp"
            v-model="searchForm.firstTypeCode"></el-cascader>
      </el-form-item>
      <el-form-item :label="$t('发布者编号')">
        <el-input :placeholder="$t('发布者编号')" v-model="searchForm.userNum" clearable/>
      </el-form-item>
      <el-form-item :label="$t('发布者昵称')">
        <el-input :placeholder="$t('发布者昵称')" v-model="searchForm.nickname" clearable/>
      </el-form-item>
      <el-form-item :label="$t('菜谱属性')">
        <dict-select flag="RECIPE_ATTRS" v-model="searchForm.property" clearable/>
      </el-form-item>
      <el-form-item :label="$t('会员等级')">
        <el-select v-model="searchForm.vipLevelCode" :placeholder="$t('会员等级')">
          <el-option :value="item.code" :label="item.name" v-for="item in levelList" :key="item.code"/>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('用户状态')">
        <dict-select flag="AN_USER_STATUS" v-model="searchForm.userBandStatus" clearable/>
      </el-form-item>
      <!--  todo 使用国家列表    -->
      <el-form-item :label="$t('使用国家')">
        <el-input :placeholder="$t('使用国家')"/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button @click="handleReset">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <template #tab-row>
      <el-radio-group v-model="tabCurrent" class="mb16">
        <el-radio-button label="RecipeAudit">{{ $t('审核中') }}</el-radio-button>
        <el-radio-button label="OnlineRecipe">{{ $t('上架中') }}</el-radio-button>
        <el-radio-button label="StoreRecipe">{{ $t('仓库中') }}</el-radio-button>

      </el-radio-group>
    </template>

    <template #table="{height}">
      <component
          :height="height"
          :is="tabCurrent"
          :searchParams="searchForm"
          :current="tabCurrent"
          ref="list"/>
    </template>

    <template slot="other">
      <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" @close="resetForm">
        <template #title>
          <h4>{{ $t('批量审核') }}</h4>
        </template>

        <el-form label-width="auto" label-position="left" ref="form" :model="DialogFormData" :rules="rules">
          <el-form-item :label="$t('审核意见')" prop="status">
            <el-radio-group v-model="DialogFormData.auditStatus">
              <el-radio label="pass">{{ $t('通过') }}</el-radio>
              <el-radio label="noPass">{{ $t('不通过') }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item :label="$t('审核备注')" prop="auditContent">
            <el-input v-model="DialogFormData.auditContent" :placeholder="$t('请输入审核备注')" type="textarea" :rows="4"/>
          </el-form-item>
        </el-form>

        <template #footer>
          <el-button type="primary" @click="handleConfirm">{{ $t('确定') }}</el-button>
          <el-button @click="resetForm">{{ $t('重置') }}</el-button>
        </template>
      </el-dialog>
    </template>



  </ankh-list>
</template>

<script>
import RecipeAudit from "@/components/recipe/RecipeAudit";
import StoreRecipe from "@/components/recipe/StoreRecipe";
import OnlineRecipe from "@/components/recipe/OnlineRecipe";
import DictSelect from "@/components/dict/DictSelect";
import {resetEmpty} from "@/utils/common";
import {request, requestByTip} from "@/config/request";
import AnkhList from "@/components/list/AnkhList.vue";

export default {
  name: "RecipeList",
  components: {AnkhList, DictSelect, OnlineRecipe, StoreRecipe, RecipeAudit},
  data() {
    return {
      searchForm: {
        firstTypeCode: []
      },
      tableData: [],
      selection: [],
      listComp: ["RecipeAudit", "OnlineRecipe", "StoreRecipe"],
      tabCurrent: "RecipeAudit",
      showDialog: false,
      rules: {
        auditStatus: {required: true, message: this.$t('请选择审核状态'), trigger: 'blur'},
        auditContent: {required: true, message: this.$t('请输入审核备注'), trigger: 'blur'}
      },
      DialogFormData: {
        auditStatus: "pass",
        auditContent: ""
      },
      levelList: [],
      recipeCategoryList: [],
      cascaderProp: {
        checkStrictly: true,
        value: "code",
        label: "name",
        children: "sub",
      }
    }
  },
  activated() {
    this.$refs.list.handleSearch();
  },
  methods: {
    // 等级列表
    async loadLevelList() {
      try {
        const res = await request(this.$api.vipLevel.list, {onPage: false});
        this.levelList = res.vipLevels;
      } catch (e) {
        console.log(e);
      }
    },

    // 菜谱分类
    async handleLoadCategory() {
      try {
        let res = await request(this.$api.cookbookSort.list, {onPage: false});
        this.recipeCategoryList = res.cookbookSorts;
      } catch (e) {
        console.error(e);
      }
    },

    // 批量下架
    async handleBatchOffline() {
      try {
       const selection = this.$refs.list.selection;
        const codes = selection.map(item => item.code);
        if (!codes.length) {
          this.$message.warning(this.$t('请选择需要下架的记录'));
          return;
        }
        await requestByTip(this.$api.cookbook.batchDown, codes,  {isJson: true}, {message: this.$t('是否确认下架')});
        this.$message.success(this.$t('操作成功'));
        const listRef = this.$refs.list.getList();
        listRef.handleRequest(codes.length);
      } catch (e) {
        console.log(e);
      }
    },

    // 批量删除
    async handleBatchDelete() {
      try {
        const selection = this.$refs.list.selection;
        const codes = selection.map(item => item.code);
        if (!codes.length) {
          this.$message.warning(this.$t('请选择需要删除的记录'));
          return;
        }
        await requestByTip(this.$api.cookbook.batchDelete, codes, {isJson: true}, {message: `${this.$t('是否确定删除选择记录')} ？`});
        this.$message.success(this.$t('操作成功'));
        const listRef = this.$refs.list.getList();
        listRef.handleRequest(codes.length);
      } catch (e) {
        console.log(e);
      }
    },

    // 批量审核
    async handleBatchPass() {
      const selection = this.$refs.list.selection;
      if (!selection.length) {
        console.log(this.selection.length)
        this.$message({
          type: 'warning',
          message: this.$t('未选择记录')
        });
        return;
      } else {
        this.showDialog = true;
      }
    },
    handleReset() {
      resetEmpty(this.searchForm);
    },
    resetForm() {

      this.$refs.form.resetFields();
      this.DialogFormData.status = 'pass';
    },

    handleConfirm() {
      const selection = this.$refs.list.selection;

      if (!selection.length) {
        return
      }
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        else {
          let params = selection.map(item => {
            return {
              "num": item.num, "auditStatus": this.DialogFormData.auditStatus, "auditContent": this.DialogFormData.auditContent
            }
          })
          console.log(params)
          await request(this.$api.cookbook.batchAudit, params,{isJson: true});
          this.$message.success(this.$t('操作成功'));
          this.showDialog=false;
          const listRef = this.$refs.list.getList();
          listRef.handleRequest();

        }

      })
    }
  },
  created() {
    this.loadLevelList();
    this.handleLoadCategory();
  }
}
</script>

<style scoped>
/deep/ .el-dialog {
  width: 450px;
  border-radius: 10px;
}
</style>
